import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faHospitalUser,
    faFileInvoiceDollar,
    faArrowRight,
    faCheckCircle,
    faLayerGroup
} from "@fortawesome/free-solid-svg-icons";
import zohoquickbooks from "./img/Integrations/img.png"
import charmhealth from "./img/Integrations/charm-icon.png"

import "./css/CharmhealthPage.css";

import charmhealth1 from "./img/Charmhealth/poster-changes.jpg.jpeg";

const CharmhealthPage = () => {
    return (
        <div className="charmhealth-wrapper">
            <div className="charmhealth-container">
                {/* MAIN TITLE */}
                <h1 className="main-title">Charmhealth – QuickBooks Integration</h1>

                {/* HERO SECTION */}
                <section className="hero-section">
                    <div className="hero-left">
                        {/* Changed from badge to a clean heading */}
                        <h2 className="hero-subtitle">Integration Overview</h2>
                        <p className="hero-description">
                            Our Standard Integration enables seamless synchronization between Charmhealth and QuickBooks,
                            ensuring accurate financial and operational data flow between healthcare and accounting systems.
                        </p>
                    </div>

                    <div className="hero-right">
                        <div className="video-wrapper">
                            <iframe
                                src="https://www.youtube.com/embed/oFK9iTNXTuo?rel=0"
                                title="Charmhealth to QuickBooks Online"
                                frameBorder="0"
                                allow="picture-in-picture"
                                allowFullScreen
                                loading="lazy"
                            ></iframe>
                        </div>
                    </div>
                </section>

                {/* DATA FLOW SECTION */}
                <section className="integration-overview">
                    <h3 className="section-title-charm">Data Flow Overview</h3>
                    <div className="mapping-grid">
                        <div className="mapping-card source">
                            <h4>
                                <img src={charmhealth} alt="charmhealth" className="imgDataInter" />
                                From Charmhealth
                            </h4>
                            <ul>
                                <li>Patients</li>
                                <li>Products</li>
                                <li>Procedure Codes</li>
                                <li>Invoices (Create / Update / Cancel)</li>
                                <li>Receipts (Payments) (Create / Update / Void)</li>
                                <li>Inventory (Stock Quantity) *</li>
                            </ul>
                        </div>

                        {/* Arrow using FontAwesome */}
                        <div className="flow-arrow-center">
                            <FontAwesomeIcon icon={faArrowRight} className="ArrowRightInter" className="imgDataInter" />
                        </div>

                        <div className="mapping-card destination">
                            <h4>
                                <img src={zohoquickbooks} alt="zohoquickbooks" />
                                To QuickBooks
                            </h4>
                            <ul>
                                <li>Customers</li>
                                <li>Inventory Items</li>
                                <li>Service Items</li>
                                <li>Invoices (Create / Update / Cancel)</li>
                                <li>Customer Payments (Create / Update / Void)</li>
                                <li>Items (Stock Quantity) *</li>
                            </ul>
                        </div>
                    </div>
                </section>

                {/* IMAGE & BENEFITS SECTION */}
                <section className="benefits-section">
                    <div className="benefits-layout">
                        <div className="benefits-image">
                            <img
                                src={charmhealth1}
                                alt="Integration Flow Diagram"
                                loading="lazy"
                            />
                        </div>
                        <div className="benefits-content">
                            <h3 className="section-title">Key Benefits</h3>
                            <ul className="benefits-list">
                                <li><FontAwesomeIcon icon={faCheckCircle} className="icon-check" /> Accurate financial tracking</li>
                                <li><FontAwesomeIcon icon={faCheckCircle} className="icon-check" /> Real-time invoice synchronization</li>
                                <li><FontAwesomeIcon icon={faCheckCircle} className="icon-check" /> Automated payment updates</li>
                                <li><FontAwesomeIcon icon={faCheckCircle} className="icon-check" /> Reduced manual data entry</li>
                                <li><FontAwesomeIcon icon={faCheckCircle} className="icon-check" /> Improved inventory visibility</li>
                                <li><FontAwesomeIcon icon={faCheckCircle} className="icon-check" /> Elimination of duplicate records</li>
                            </ul>
                        </div>
                    </div>
                </section>

                {/* ADVANCED INTEGRATION SECTION */}
                <section className="advanced-integration-card">
                    <div className="advanced-header">
                        <FontAwesomeIcon icon={faLayerGroup} className="icon-dark-blue" />
                        <h3>Advanced Integration (Multiple Facilities)</h3>
                    </div>
                    <div className="advanced-body">
                        <div className="advanced-text">
                            <p>By default, each integration supports <strong>one facility only</strong>. If your organization operates multiple facilities and requires:</p>
                            <ul className="styled-list">
                                <li>Integration of multiple Charmhealth facilities</li>
                                <li>Synchronization into one or multiple QuickBooks company files</li>
                            </ul>
                        </div>
                        <div className="advanced-footer">
                            <p>This can be implemented as an <strong>Advanced Integration Solution</strong>. Additional cost applies for multi-facility integrations due to added complexity, mapping, and data handling requirements.</p>
                        </div>
                    </div>
                </section>

            </div>
        </div>
    );
};

export default CharmhealthPage;